<template>
  <v-container>
    <v-form lazy-validation ref="form" v-if="pageId.data">
      <template v-if="interfaceData.data && textData.data">
        <DevInput
          v-if="interfaceData.data[2]"
          :text="t['title']"
          v-model="interfaceData.data[2].value"
        />
        <v-input hide-details class="text--darken-1 font12">
          {{ t['article_text'] }}
        </v-input>
        <VueEditor
          v-if="textData.data[1]"
          v-model="textData.data[1].value"
          @input="checkLink"
        />
        <v-card class="my-5 px-4 pt-4 border text-start">
          <DevInput
            v-if="interfaceData.data[3]"
            :text="t['title']"
            v-model="interfaceData.data[3].value"
          />
          <div class="d-flex flex-wrap gap-4">
            <DevInput
              v-if="interfaceData.data[2]"
              :text="t['title']"
              v-model="interfaceData.data[2].value"
            />
            <DevInput
              v-if="interfaceData.data[5]"
              :text="t['sales']"
              v-model="interfaceData.data[5].value"
            />
          </div>
          <div class="d-flex flex-wrap gap-4">
            <DevInput
              v-if="interfaceData.data[1]"
              :text="t['title']"
              v-model="interfaceData.data[1].value"
            />
            <DevInput
              v-if="interfaceData.data[4]"
              :text="t['percent']"
              v-model="interfaceData.data[4].value"
            />
          </div>
          <div class="d-flex flex-wrap gap-4">
            <DevInput
              v-if="interfaceData.data[0]"
              :text="t['total_price']"
              v-model="interfaceData.data[0].value"
            />
          </div>
        </v-card>
        <v-input hide-details class="text--darken-1 font12">
          {{ t['article_text'] }}
        </v-input>
        <VueEditor
          v-if="textData.data[0]"
          v-model="textData.data[0].value"
          @input="checkLink"
        />
      </template>
      <v-card class="my-5 pa-4 border text-start">
        SEO
        <div class="grid_seo">
          <div>
            <DevInput
              v-model="pageId.data['seo_title']"
              :text="t['title']"
              :rules="[v => !!v || t['required_field']]"
            />
            <DevInput
              v-model="pageId.data['keywords']"
              :text="t['keywords']"
              :rules="[v => !!v || t['required_field']]"
            />
          </div>
          <div>
            <div>
              <v-input hide-details class="font12 text-center">
                {{ t['image'] }}
              </v-input>
              <DevImageBlock :images="[pageId.data.image]" contain :on-update="loadImage"/>
            </div>
          </div>
          <DevInput
            v-model="pageId.data['description']"
            :text="t['description']"
            text-area
            :rules="[v => !!v || t['required_field']]"
            class="mb-n4"
          />
        </div>
      </v-card>
    </v-form>
    <input
      type="file"
      id="file"
      ref="file"
      :accept="'.JPG, .PNG, .SVG, .GIF, .WebP'"
      style="display: none"
      v-on:change="handleFileUpload()"
    />
    <div class="fixed_btn">
      <v-btn @click="saveData" color="primary" fab>
        <v-icon class="min">mdi-upload</v-icon>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {VueEditor} from "vue2-editor";
import DevInput from "components/dev/DevInput";
import DevImageBlock from "components/dev/DevImageBlock";
import DefaultPageAskDelete from "components/default/page/DefaultPageAskDelete";

export default {
  name: "calculator",
  components: {DefaultPageAskDelete, DevImageBlock, DevInput, VueEditor},
  computed: {
    ...mapGetters(["file"]),
    ...mapGetters('pages', ['pageList', 'pageId']),
    ...mapGetters('interfaceData', ['interfaceGroupList', 'interfaceData', 'textData']),
    t() {
      return Object.assign(
        this.$store.state.t[this.$route.params.language]['fields'],
        this.$store.state.t[this.$route.params.language]['form'],
        this.$store.state.t[this.$route.params.language]['buttons']
      )
    },
  },
  data: () => ({
    deleted_files: [],
    new_files: [],
    click_save: false,
    load_file: '',
    toolbar: [
      [{header: [false, 1, 2, 3, 4, 5, 6]}],
      ["bold", "italic"],
      [
        {align: ""},
        {align: "center"},
        {align: "right"},
        {align: "justify"}
      ],
      ["blockquote"],
      [{list: "ordered"}, {list: "bullet"}],
      [{indent: "-1"}, {indent: "+1"}],
      [{color: ['#277faf', '#212121']}],
      ["link"],
      ["clean"]
    ],
  }),
  watch: {
    load_file() {
      this.submitFile();
    },
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions(['uploadFile', 'destroyFile']),
    ...mapActions('pages', ['onPageList', 'onPage', 'onPageSave', 'onPageCreate']),
    ...mapActions('interfaceData',
      ['onInterfaceGroupCreate', 'onInterfaceGroupList', 'onInterfaceData', 'onTextData', 'onTextDataSave',
        'onInterfaceDataDelete', 'onInterfaceDataCreate', 'onInterfaceDataSave', 'onInterfaceDataSavePage']),
    async getData() {
      await this.onPage(35)
      await this.onInterfaceData({id: 59})
      await this.onTextData({id: 59})
    },
    checkLink() {
      if (this.textData && this.textData.data[0]) {
        let blank = this.textData.data[0].value.indexOf('<a href="/')
        if (blank > 0) {
          let temp = this.textData.data[0].value.split('<a href="/')
          this.textData.data[0].value = temp[0] + '<a href="/' + temp[1].replace('target="_blank"', '')
        }
        let blank1 = this.textData.data[1].value.indexOf('<a href="/')
        if (blank > 0) {
          let temp1 = this.textData.data[1].value.split('<a href="/')
          this.textData.data[1].value = temp1[0] + '<a href="/' + temp1[1].replace('target="_blank"', '')
        }
      }
    },
    onClose() {
      if (this.click_save) {
        for (let del in this.deleted_files) {
          this.destroyFile(this.deleted_files[del])
        }
      } else {
        for (let del in this.new_files) {
          this.destroyFile(this.new_files[del])
        }
      }
      this.deleted_files = []
      this.new_files = []
      this.click_save = false
    },
    loadImage() {
      this.$refs.file.click();
    },
    handleFileUpload() {
      this.click_save = false
      this.load_file = this.$refs.file.files[0];
    },
    async submitFile() {
      let formData = new FormData();
      formData.append("file", this.load_file);
      await this.uploadFile({
        data: formData,
        use_case: "icon",
      }).then(() => {
        if (this.pageId.data.image && this.pageId.data.image.length > 1) {
          this.deleted_files.push(this.pageId.data.image)
        }
        this.pageId.data.image = this.file.url
        this.new_files.push(this.file.url)
      });
    },
    saveData() {
      if (this.$refs.form.validate()) {
        this.click_save = true
        let result = []
        for (let i in this.interfaceData.data) {
          result.push({
            interface_entity_id: this.interfaceData.data[i].id,
            value: this.interfaceData.data[i].value || '-'
          })
        }
        this.onInterfaceDataSave({
          language_id: 1,
          translations: result
        })
        this.onTextDataSave({
          language_id: 1,
          translations: [
            {
              text_entity_id: this.textData.data[0].id,
              value: this.textData.data[0].value
            },
            {
              text_entity_id: this.textData.data[1].id,
              value: this.textData.data[1].value
            },
          ]
        })
        this.pageId.data.language_id = 1
        this.onPageSave({id: 35, data: this.pageId.data})
        this.onClose()
      }
    },
  }
}
</script>

<style scoped>

</style>